import React from "react";
import "../App.css";

const Overview = () => {
  return (
    <section id="overview" className="overview-clean">
      <div className="overview-container">
        <h2 className="overview-title">Project Overview</h2>

        <p className="overview-intro">
          Mardacannes Residence is an exclusive enclave of 17 luxury villas,
          thoughtfully designed for families who value elegance, comfort, and
          time together. Blending modern architecture with natural serenity, it
          offers a refined lifestyle where every detail enhances peace, privacy,
          and connection to nature.
        </p>

        <div className="overview-details">
          <div className="overview-left">
            <h3>Our Vision</h3>
            <p>
              To create a distinguished community where luxury, comfort, and
              peace coexist. Offering residents a refined living experience in a
              secure, green, and elegant environment.
            </p>
          </div>
          <div className="overview-right">
            <h3>Our Mission</h3>
            <p>
              To provide an eco-conscious, technologically advanced, and secure
              living environment where every detail — from architecture to
              amenities — enhances comfort, privacy, and the joy of modern
              living.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Overview;
